/* Original name @uswitch/trustyle.hero-secondary */

import React from 'react'
import { useThemeUI } from 'theme-ui'
import { Palette } from '../palette'

const makeStyles = variant => element =>
  `elements.hero${variant ? `.variants.${variant}` : ''}${element ? `.${element}` : ''}`

const get = (obj, path, defaultValue) => {
  // Potential vulnerability if coming from user data
  if (path.includes('__proto__')) {
    throw new Error('Not allowed to use __proto__ in paths')
  }

  const travel = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj)

  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/)

  return result === undefined || result === obj ? defaultValue : result
}

const DefaultContainer = ({ children }) => (
  <div sx={{ maxWidth: 1024, margin: '0 auto', paddingX: 10 }}>{children}</div>
)

const HeroSecondary = ({
  breadcrumbs,
  container: Container = DefaultContainer,
  image,
  imageOnMobile = true,
  imageOnTablet = true,
  customBgColor = '',
  children,
  variant = 'secondary',
  className,
}) => {
  const { theme } = useThemeUI()
  const styles = makeStyles(variant)
  const breadcrumbVariant = get(theme, styles('breadcrumbs.variant'))
  const breadcrumbWithVariant =
    breadcrumbs && React.cloneElement(breadcrumbs, { variant: breadcrumbVariant })

  return (
    <Palette
      as='div'
      sx={{ overflow: 'hidden', variant: styles('wrapper') }}
      px={{ backgroundColor: 'backgroundColor' }}
    >
      <div
        sx={{
          position: 'relative',
          overflow: 'hidden',
          background: customBgColor || undefined,
        }}
        className={className}
      >
        <Container sx={{ variant: styles('container') }}>
          {breadcrumbs && (
            <div sx={{ paddingTop: 'sm', variant: styles('breadcrumbs') }}>
              {breadcrumbWithVariant}
            </div>
          )}

          <div
            sx={{
              paddingTop: ['sm', 'xxl'],
              paddingBottom: ['sm', 'xxl'],
              display: 'flex',
              flexDirection: ['row', 'column'],
              variant: styles('content'),
            }}
          >
            {image && (
              // eslint-disable-next-line jsx-a11y/alt-text
              <img
                src={image}
                role='presentation'
                sx={{
                  display: [
                    imageOnMobile ? 'block' : 'none',
                    imageOnTablet ? 'block' : 'none',
                    'block',
                  ],
                  variant: styles('image'),
                }}
              />
            )}

            {children}
          </div>
        </Container>
      </div>
    </Palette>
  )
}

export default HeroSecondary
